export default (store, { itemId }) => {
  const currentProjectId = parseInt(itemId, 10);

  const currentProject = store.getters['project/current'];
  if (currentProject && currentProject.id === currentProjectId) {
    store.dispatch('project/changeNotification', currentProjectId); // app.UpdateProjectAndPermissions
  }
};
